import store from '@/store'
import useNotifications from '@/composables/useNotifications'
import { useRouter } from '@core/utils/utils'
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import { useLambda } from '@/views/habit/awsLambda'
import { oid } from '@/helpers/mongoHelpers'
import { hasPermission } from '@/composables/usePermission'
import useAuditLog from '@/composables/useAuditLog'

export default function useLocationAdd() {
  const { showSuccessMessage, showErrorMessage } = useNotifications()
  const { router } = useRouter()
  const { createItem } = useLambda()
  const { createInitialAuditEntry } = useAuditLog()
  const userData = store.state?.userStore?.userData
  const location = ref({})
  const isSubmitting = ref(false)
  const collection = 'location'

  async function create(data) {
    if (!hasPermission('organization-locations', 'create')) {
      showErrorMessage(i18n.t('message.you_are_not_authorized'))
      return
    }

    isSubmitting.value = true

    try {
      const payload = {
        client_id: oid(userData.client.$oid),
        history: [createInitialAuditEntry()],
      }

      if (data.location?.value) payload.location = data.location.value
      if (data.zone?.value) payload.zone = data.zone.value
      if (data.agency?.value) payload.agency = data.agency.value

      await createItem({ collection, payload })

      showSuccessMessage(i18n.t('message.location_added'))
    } catch (error) {
      console.log(error)
      showErrorMessage(i18n.t('message.location_add_error'))
    } finally {
      router.push({ name: 'organization-location-list' })
      isSubmitting.value = false
    }
  }

  return {
    create,
    location,
    isSubmitting,
  }
}
